import { createDialog } from '../dialog'
import { fetchUnreadOfferNotificationsCount } from '../fetch'
import { globalState } from '../globalState'
import { Handlers, WebshopEvents } from '../types'
import { createSessionId, log } from '../utils'
import { createIframeUrl } from '../utils/url'

export const onSalesPageOpen = (): void => {
    log('OnOpenSalesOffersPage')
    const { isCanvas } = globalState.getStore()
    if (isCanvas) {
        window.CanvasAgent?.instance?.navigate('supersale')
        return
    }

    const sid = createSessionId()
    const url = createIframeUrl({
        page: 'sale-offers',
        sid,
    })
    createDialog(url)
}

export const onLemonstandClose = (): void => {
    const { isCanvas } = globalState.getStore()
    log('onLemonstandClose', isCanvas)
    if (!isCanvas) {
        fetchUnreadOfferNotificationsCount()
    }
}

export const createPostMessageHandlers = (): Handlers => {
    return {
        [WebshopEvents.CXF_OPEN_SALES_MSG]: onSalesPageOpen,
        [WebshopEvents.CXF_DIALOG_CLOSE]: onLemonstandClose,
    }
}
